<template>
  <multi-selection-tool-button
    icon="mdi-playlist-plus"
    :icon-size="15"
    :disabled="disabled"
    :tooltip="$t('AddToList')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";

export default {
  name: "HomeFormTableAddToOtherListTool",

  components: { MultiSelectionToolButton },

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/AddToList.vue